import { react2angular } from 'react2angular';
import app from '../../../browser/addform/scripts/app';
import { MLSNPublicationBannerWrapper } from './MLSNPublicationBanner.container';

app.component(
  'mlsnPublicationBanner',
  react2angular(MLSNPublicationBannerWrapper, [], ['config', 'logger', 'httpApi']),
);
